import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const EditContainer = styled(Stack)`
  height: 100%;
  max-height: 475px;
  overflow-y: scroll;
  gap: 8px;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;

  /* Chrome, Edge, Safari */
  &::-webkit-scrollbar {
    width: 6px;
    margin-right: 20px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin-right: 16px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    margin-right: 16px;

    &:hover {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  padding-right: 12px;
`;

export const ParameterRow = styled(Stack)`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 36px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;
